import { makeApiCall } from '../core';
import type { ItemEnvelope, PlatformPlanId, ResolvedPlatformPolicies } from '@ruta/shared';

export interface PlatformConfig {
  payment: {
    webComponentToken: string;
    subaccountId: string;
  };
  /** Ruta's own terms & privacy addresses, and whether each is set or built-in. */
  policies: ResolvedPlatformPolicies;
  features: Record<string, any>;
}

/** JustiFi modular-checkout session against the platform subaccount. */
export interface PlatformCheckoutSession {
  checkoutId: string;
  webComponentToken: string;
  accountId: string;
  amount: number;
  /** The one published plan — the API accepts only `PLATFORM_PLAN_IDS`. */
  pricingTier: PlatformPlanId;
  /** False when JustiFi ACH is off for the platform sub-account — bank form stays empty. */
  achPaymentsEnabled?: boolean;
}

export const platformApi = {
  /**
   * Get platform configuration including payment setup
   */
  async getConfig(): Promise<PlatformConfig> {
    const res = await makeApiCall<ItemEnvelope<PlatformConfig>>('GET', '/platform/config');
    return res.data;
  },

  /**
   * Mint a JustiFi checkout session for the modular checkout surface
   * (card + ACH). Pass amount: 1 for save-a-method (never completed).
   */
  async createCheckoutSession(input: {
    amount?: number;
    pricingTier: PlatformPlanId;
    description?: string;
  }): Promise<PlatformCheckoutSession> {
    const res = await makeApiCall<ItemEnvelope<PlatformCheckoutSession>>(
      'POST',
      '/platform/checkout-session',
      {
        amount: input.amount ?? 1,
        pricingTier: input.pricingTier,
        ...(input.description ? { description: input.description } : {}),
      },
    );
    return res.data;
  },
};
